/*
 * Copyright (c) 2020 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Ritika Khare
*/
import { unloadNuance } from '../../lib/store/nuance/actions';
import NavigationItemRecord from '../../lib/records/NavigationItemRecord';
export var keepAlive = function keepAlive() {
  window.WF_SESSION.keepAlive();
};
export var closeEvent = function closeEvent(dispatch) {
  dispatch(unloadNuance());
};
export var samlDataResponse = function samlDataResponse(data, uuid) {
  var samlPayload = data.samlPayLoadTO ? data.samlPayLoadTO : {};
  window.WFUI_BRIDGE.postMessageToChildren(uuid, {
    command: 'NEW_PAGE_DATA',
    brData: {
      SAMLResponse: samlPayload.payload,
      targetUrl: samlPayload.targetUrl
    }
  });
};
export var getNavigationItem = function getNavigationItem(navigationResponse) {
  var _ref = navigationResponse.linkNavigationViewBean || navigationResponse || {},
      displayType = _ref.displayType,
      url = _ref.url,
      browserMode = _ref.browserMode,
      confirmRequired = _ref.confirmRequired,
      _ref$linkStaticConfig = _ref.linkStaticConfig,
      linkStaticConfig = _ref$linkStaticConfig === void 0 ? {} : _ref$linkStaticConfig;

  var _linkStaticConfig$lin = linkStaticConfig.linkNonSamlAttributes,
      linkNonSamlAttributes = _linkStaticConfig$lin === void 0 ? {} : _linkStaticConfig$lin,
      _linkStaticConfig$lin2 = linkStaticConfig.linkSamlAttributes,
      linkSamlAttributes = _linkStaticConfig$lin2 === void 0 ? {} : _linkStaticConfig$lin2;
  var linkAttribute = displayType === 'saml' ? linkSamlAttributes : linkNonSamlAttributes;
  var navigationUrl = url;
  var deviceFeature = '';

  if (linkSamlAttributes['data-device-feature']) {
    deviceFeature = linkSamlAttributes['data-device-feature'];
  }

  return new NavigationItemRecord({
    navigationUrl: navigationUrl,
    displayType: displayType,
    deviceFeature: deviceFeature,
    nativeNavigationType: 'external',
    externalNavigation: 'external' === linkAttribute['data-link-type'] || confirmRequired === 'confirm-dispatch',
    forceWindow: 'true' === linkAttribute['data-force-window'] || browserMode === 'externalBrowser'
  });
};